// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import PermissionService from '../../../services/permission'

export const getPermissions = createAsyncThunk('permission/getPermissions', async (params, { rejectWithValue }) => {
  try {
    const response = await PermissionService.getPermissions(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getPermissionById = createAsyncThunk('permission/getPermissionById', async (id) => {
  const response = await PermissionService.getPermissionIndividual(id)
  return response
})

export const addPermission = createAsyncThunk('permission/addPermission', async (permission, { rejectWithValue }) => {
  try {
    const response = await PermissionService.addPermission(permission)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updatePermissions = createAsyncThunk('permission/updatePermissions', async (permission, { rejectWithValue }) => {
  try {
    const response = await PermissionService.updatePermissionIndividual(permission)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

// export const deletePermissions = createAsyncThunk('permission/deletePermissions', async (id, { dispatch, getState }) => {
//   await PermissionService.deletePermissions(id)
//   await dispatch(getMember(getState()?.memberships.params))
//   return id
// })

export const permissionSlice = createSlice({
  name: 'permissions',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualPermission: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPermissions.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getPermissionById.fulfilled, (state, action) => {
        state.individualPermission = action.payload
        state.loading = false
      })
      .addCase(getPermissionById.pending, (state, action) => {
        state.individualPermission = action.payload
        state.loading = true
      })
      .addCase(getPermissionById.rejected, (state, action) => {
        state.individualPermission = action.payload
        state.loading = false
      })
  }
})

export default permissionSlice.reducer
